<app-layout title="Periodos">
  <div class="container">
    <div class="mb-3 row justify-content-between align-items-center">
      <div class="col-md-4">
        <form [formGroup]="yearForm" (ngSubmit)="loadPeriods()">
          <div class="d-flex align-items-center justify-content-end">
            <label for="yearSelect" class="form-label me-3 mb-0">Seleccionar Año:</label>
            <select id="yearSelect" class="form-select form-select-sm" formControlName="selectedYear">
              <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
            <button type="submit" class="btn btn-primary btn-sm ms-3">Confirmar</button>
          </div>
        </form>
      </div>
      <div class="col-md-2">
        <button type="button" class="btn btn-success btn-sm w-100" data-bs-toggle="modal"
          data-bs-target="#addPeriodModal">
          Abrir Periodo
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-hover table-sm align-middle border border-secondary rounded-4 mt-4">
        <thead class="table-primary text-center">
          <tr>
            <th>Periodo</th>
            <th>Valor FMR</th>
          <th>Valor UF</th>
          <th>Fecha Apertura</th>
          <th>Fecha Cierre</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let periodo of periods" class="text-center">
          <td>{{ periodo.name }}</td>

          <!-- Buscar FMR usando el Pipe -->
          <td>${{ periodo.variables | variableFilter: 'FMR' | number:'1.0-0' }}</td>

          <!-- Buscar Bencina usando el Pipe -->
          <td>${{ periodo.variables | variableFilter: 'UF' | number:'1.0-0' }}</td>
          <td>
            {{ periodo.createdAt | date:'dd-MM-yyyy':'CL' }}
          </td>

          <td>
            {{ periodo.updatedAt | date:'dd-MM-yyyy':'CL' }}
          </td>

          <td>
            <span class="badge" [ngClass]="{'bg-success': !periodo.isClosed, 'bg-danger': periodo.isClosed}">
              {{ periodo.isClosed ? 'Cerrado' : 'Abierto' }}
            </span>
          </td>
          <td>
            <button class="btn btn-warning btn-sm me-1" title="Editar" (click)="openEditModal(periodo)">
              <i class="bi bi-pencil-square"></i>
            </button>
            <!-- <button class="btn btn-outline-danger btn-sm" title="Eliminar">
              <i class="bi bi-trash"></i>
            </button> -->
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="addPeriodModal" tabindex="-1" aria-labelledby="addPeriodModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addPeriodModalLabel">
              {{ isEdit ? 'Editar Período' : 'Agregar Período' }}
            </h5> <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form [formGroup]="periodForm">
              <!-- Año (Deshabilitado) -->
              <div class="mb-3">
                <label class="form-label">Año</label>
                <input type="text" class="form-control" formControlName="year">
              </div>

              <!-- Mes (Deshabilitado) -->
              <div class="mb-3">
                <label class="form-label">Mes</label>
                <input type="text" class="form-control" formControlName="month">
              </div>

              <!-- Valor FMR -->
              <div class="mb-3">
                <label class="form-label">Valor FMR</label>
                <input type="number" class="form-control" formControlName="fmrValue" placeholder="Ingrese el valor FMR">
                <small class="text-danger"
                  *ngIf="(periodForm.get('fmrValue')?.invalid && periodForm.get('fmrValue')?.touched)">
                  ⚠️ Campo obligatorio. Debe ser mayor a 0.
                </small>
              </div>

              <!-- Valor Bencina -->
              <div class="mb-3">
                <label class="form-label">Valor UF</label>
                <input type="number" class="form-control" formControlName="bencinaValue"
                  placeholder="Ingrese el valor de la UF">
                <small class="text-danger"
                  *ngIf="(periodForm.get('bencinaValue')?.invalid && periodForm.get('bencinaValue')?.touched)">
                  ⚠️ Campo obligatorio. Debe ser mayor a 0.
                </small>
              </div>

              <!-- Estado del Periodo -->
              <div class="mb-3">
                <label class="form-label">Estado</label>
                <select class="form-select" formControlName="isClosed">
                  <option [value]="false">Abierto</option>
                  <option [value]="true">Cerrado</option>
                </select>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">Cancelar</button>
                <button type="button" class="btn btn-primary" [disabled]="periodForm.invalid"
                  (click)="isEdit ? updatePeriod() : savePeriod()">
                  {{ isEdit ? 'Actualizar' : 'Guardar' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>